import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export function useRouteChangeStatus() {
  const router = useRouter();
  const {
    0: isRouting,
    1: setIsRouting
  } = useState(false);
  useEffect(() => {
    const handleStart = () => {
      setIsRouting(true);
    };
    const handleComplete = () => {
      setIsRouting(false);
    };
    const handleError = () => {
      setIsRouting(false);
    };
    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleError);
    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleError);
    };
  }, [router.events]);
  return {
    isRouting
  };
}